<template>
    <div class="relative">
        <CCard>
            <CCardHeader>
                <p>Главное меню десктопа</p>
            </CCardHeader>
            <CCardBody v-if="model">
                <template v-for="(menuItem, mIndex) in model.settings.menu">
                    <CRow :key="`menuItem-${mIndex}`">
                        <CCol sm="6">
                            <CInput
                                v-model="menuItem.title"
                                placeholder="Заголовок"
                            />
                        </CCol>
                        <CCol sm="5">
                            <CInput
                                v-model="menuItem.link"
                                placeholder="Ссылка"
                            />
                        </CCol>
                        <CCol sm="1">
                            <CButton
                                class="ml-auto"
                                color="danger"
                                @click="removeMenu(mIndex)">
                                Удалить
                            </CButton>
                        </CCol>
                        <CCol sm="12">
                            <CRow class="px-4">
                                <CCol sm="12">
                                    <label>Подменю</label>
                                </CCol>
                            </CRow>
                            <template v-for="(subMenuItem, sIndex) in menuItem.items">
                                <CRow :key="`subMenuItem-${mIndex}-${sIndex}`" class="px-4">
                                    <CCol sm="6">
                                        <CInput
                                            v-model="subMenuItem.title"
                                            placeholder="Заголовок"
                                        />
                                    </CCol>
                                    <CCol sm="5">
                                        <CInput
                                            v-model="subMenuItem.link"
                                            placeholder="Ссылка"
                                        />
                                    </CCol>
                                    <CCol sm="1">
                                        <CButton
                                            class="ml-auto"
                                            color="danger"
                                            @click="removeSubMenu(mIndex, sIndex)">
                                            Удалить
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </template>
                            <CRow class="px-4 pb-4 mb-4" style="border-bottom: 1px solid #d8dbe0">
                                <CCol sm="12" class="text-right">
                                    <CButton
                                        class="ml-auto"
                                        color="primary"
                                        @click="addSubMenu(mIndex)">
                                        Добавить пункт подменю
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </template>
                <CRow>
                    <CCol sm="12">
                        <CButton
                            class="ml-auto"
                            color="primary"
                            @click="addMenu">
                            Добавить пункт меню
                        </CButton>
                    </CCol>
                </CRow>
            </CCardBody>

            <CCardFooter>
                <CButton
                    class="ml-auto"
                    color="primary"
                    @click="submit">
                    Сохранить
                </CButton>
            </CCardFooter>
        </CCard>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
    </div>
</template>

<script>
    import { cilSettings } from '@coreui/icons';

    export default {
        icons: {
            cilSettings
        },

        data: () => ({
            isPending: false,
            model: {
                id: 0,
                page: 'desktop_menu',
                settings: {
                    menu: [
                        {
                            title: '',
                            link: '',
                            items: [
                                {
                                    title: '',
                                    link: ''
                                }
                            ]
                        }
                    ]
                }
            }
        }),

        async created() {
            await this.fetchEntity();
        },

        methods: {
            addMenu() {
                this.model.settings.menu.push({
                    title: '',
                    link: '',
                    items: []
                });
            },
            addSubMenu(mIndex) {
                this.model.settings.menu[mIndex].items.push({
                    title: '',
                    link: ''
                });
            },
            removeMenu(mIndex) {
                this.model.settings.menu.splice(mIndex, 1);
            },
            removeSubMenu(mIndex, sIndex) {
                this.model.settings.menu[mIndex].items.splice(sIndex, 1);
            },

            async fetchEntity() {
                try {
                    this.isPending = true
                    const { data } = await this.axios.get('/page-settings/desktop_menu');
                    if (data && data.settings) {
                        this.model = data;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },

            async submit() {
                try {
                    this.isPending = true
                    const { id, ...data } = this.model;
                    if (id) {
                        await this.axios.put(`/page-settings/${id}`, data)
                    } else {
                        await this.axios.post('/page-settings', data)
                    }
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },
        }
    }
</script>